import { makeStyles, Typography } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles(
  _ => ({
    rowLabel: {
      color: "#247CFF",
      fontSize: "0.9rem",
      marginRight: "5px"
    },
    rowLabelSeeMore: {
      alignItems: "center",
      borderTop: "1px solid rgba(0,0,0,0.1)",
      color: "#247CFF",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      margin: "0"
    },
    updateRow: {
      fontSize: "0.9rem",
      padding: "10px 10px 5px",
      position: "relative",
      width: "100%"
    }
  }),
  { name: "SeeMoreSeeLess" }
);

interface SeeMoreSeeLessProps {
  totalLength: number;
  spliceLength: number;
  setSpliceLength: React.Dispatch<React.SetStateAction<number>>;
}

const SeeMoreSeeLess: React.FC<SeeMoreSeeLessProps> = props => {
  const { totalLength, spliceLength, setSpliceLength } = props;
  const classes = useStyles({});

  return (
    <div
      className={`${classes.updateRow} ${classes.rowLabelSeeMore}`}
      onClick={() => {
        if (spliceLength === 3) {
          setSpliceLength(totalLength);
        } else {
          setSpliceLength(3);
        }
      }}
    >
      <Typography>
        <span className={`${classes.rowLabel}`}>
          {spliceLength === 3 ? "See More" : "See Less"}
        </span>
      </Typography>
      {spliceLength === 3 ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
    </div>
  );
};

export default SeeMoreSeeLess;
